import { render } from "./AdminVessels.vue?vue&type=template&id=c8e43f7c"
import script from "./AdminVessels.vue?vue&type=script&lang=js"
export * from "./AdminVessels.vue?vue&type=script&lang=js"

import "./AdminVessels.vue?vue&type=style&index=0&id=c8e43f7c&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__